<div *ngIf="tempTinyUrl | async; else loading" class="margin-10 flex-stretch-column">
  <h3>
    Welcome to your Own Tiny URL Service.
  </h3>
  <p>
    In just a few steps, you'll be set up to use your own Tiny URL Service.
  </p>
  <mat-vertical-stepper linear="true" #stepper>
    <mat-step [stepControl]="firstFormGroup">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Enter the Domain Name</ng-template>
        <div class="mt-10">
          <mat-form-field mat-line appearance="outline">
            <mat-label>Domain Name</mat-label>
            <input matInput placeholder="Domain Name" formControlName="Url" (keyup)="checkUrl($event)" [readonly]>
          </mat-form-field>
          <span mat-line>&nbsp;</span>
          <span mat-line *ngIf="errorMsg != ''" [class]="success ? 'alert alert-warning tUrl-status-span-width' : 'alert alert-danger tUrl-status-span-width'">{{errorMsg}}</span>
          <span mat-line *ngIf="success == true && errorMsg == ''" class="alert alert-success tUrl-status-span-width">This Tiny URL is correctly configured</span>
        </div>
        <div>
          <button mat-raised-button class="mt-5" color="primary" (click)="verifyDomain(stepper);$event.preventDefault()">Verify</button>&nbsp;
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup">
      <form [formGroup]="secondFormGroup">
        <ng-template matStepLabel>Verify Your Domain Name</ng-template>

        <h3><mat-icon>cloud</mat-icon>&nbsp;IP Address</h3>
        <p>
          The IP Address for our Tiny URL is {{ipAddress}}. Make sure you are using this in your settings.
        </p>
        <h3><mat-icon>verified</mat-icon>&nbsp;TXT Verification</h3>
        <p>Add verification code to your domain settings</p>
        <mat-form-field mat-line appearance="outline" class="fullWidth">
          <mat-label>Txt String</mat-label>
          <input matInput placeholder="Txt String" formControlName="ValidationCode" readonly>
          <button matSuffix mat-icon-button aria-label="Copy" [cdkCopyToClipboard]="copyFromCode()">
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
        <br />
        <br/>
        <h3><mat-icon>card_membership</mat-icon>&nbsp;Digital Certificate</h3>
        <p>For secure access to your TinyURL service you will need to share with us a digital certificate to apply to our hosted service. Please contact clientserviceteam&#64;diysurveys.com for this to take place.</p>
        <mat-checkbox formControlName="IsHttps">Apply a Certificate</mat-checkbox>
        <br />
        <br />
        <h3><mat-icon>security</mat-icon>&nbsp;Use our secure click through technology</h3>
        <mat-checkbox class="example-margin" (click)="checkClickThru()" formControlName="ClickThru">With our secure click through technology we can remove unwanted clicks on your Tiny URL's from bots and malicious sources.</mat-checkbox>
        <div *ngIf="!secondFormGroup.controls.ClickThru.value" class="alert alert-warning" role="alert">
          <div style="display:flex;flex-flow:row">
            <div style="margin-right:5px">
              <mat-icon>warning</mat-icon>
            </div>
            <div>
              You have chosen to use the unsecure click through service and therefore accept all responsibility for any click throughs from malicious sources.
            </div>
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step *ngIf="secondFormGroup.controls.ClickThru.value" [stepControl]="thirdFormGroup">
      <form [formGroup]="thirdFormGroup">
        <ng-template matStepLabel>Click Thru Capabilities</ng-template>
        <p>
          Turn on Click Thru Capabilities and set the level of bot detection to track the number of times your Tiny URL is clicked.
        </p>
        <div>
          <mat-button-toggle-group #group="matButtonToggleGroup" formControlName="ClickThruLevel" [disabled]="!secondFormGroup.controls.ClickThru.value">
            <!--mat-button-toggle [value]="0">None</!--mat-button-toggle-->
            <mat-button-toggle [value]="1">Basic</mat-button-toggle>
            <mat-button-toggle [value]="2">Advanced</mat-button-toggle>
          </mat-button-toggle-group>
          <div>
            &nbsp;
          </div>
          <div *ngIf="thirdFormGroup.controls.ClickThruLevel?.value == 0">
            <h3>No Measurement</h3>
            <p>
              No measurement will be carried out and any clicks on your tiny URL will be counted as a valid click.
              The benefit of this is a seamless experience from your tiny URL to the long URL.
            </p>
          </div>
          <div *ngIf="thirdFormGroup.controls.ClickThruLevel?.value == 1">
            <h3>Basic Measurement</h3>
            <p>
              Basic bot detection will be carried out when a click is performed on your TinyUrl.
            </p>
          </div>
          <div *ngIf="thirdFormGroup.controls.ClickThruLevel?.value == 2">
            <h3>Advanced Settings (Recommended)</h3>
            <p>
              Advanced bot detection will be carried out when a click is perform on your TinyUrl.
              This will include a captcha facility that you can brand with your account's profile picture.
            </p>
          </div>
            <div *ngIf="thirdFormGroup.controls.ClickThruLevel?.value != 0" class="user-details-profile-pic-container">
              <div *ngIf="media == null" class="user-details-upload-pic-container">
                <div class="user-details-upload-pic-btn-container">
                  <input type="file" #file placeholder="Choose file" (change)="uploadPicture($event)" class="noDisplay" accept="image/x-png, image/gif, image/jpeg">
                  <button mat-raised-button color="primary" (click)="file.click()">Upload branding picture</button>
                </div>
              </div>
              <div *ngIf="media != null" class="user-details-upload-pic-container">
                <div>
                  <input type="file" #file placeholder="Choose file" (change)="uploadPicture($event)" class="noDisplay" accept="image/x-png, image/gif, image/jpeg">
                  <img [src]="media | safe: 'resourceUrl'" alt="Profile Image" class="user-details-avatarImage">
                </div>
                <div class="user-details-upload-pic-btn-container">
                  <button mat-raised-button color="primary" [matMenuTriggerFor]="editPicture">Edit branding</button>
                  <mat-menu #editPicture="matMenu">
                    <button mat-menu-item (click)="file.click()">Upload new branding picture</button>
                    <button mat-menu-item (click)="deleteMediaForProfile()">Delete branding picture</button>
                  </mat-menu>
                </div>
              </div>
            </div>
        </div>
        <div *ngIf="success">
          <button mat-raised-button color="primary" (click)="checkYourSettings()">Check your settings</button>
        </div>
      </form>
    </mat-step>
  </mat-vertical-stepper>
</div>

<ng-template #profileDialog>
  <div>
    <div class="user-details-dialog-container">
      <div class="leftFloat">
        <h3>Crop your new profile picture</h3>
      </div>
      <div class="rightFloat">
        <button mat-icon-button matDialogClose="no" matTooltip="Close" matTooltipPosition="below">
          <mat-icon class="user-details-dialog-close-icon">close</mat-icon>
        </button>
      </div>
    </div>
    <div class="user-details-profile-image-container">
      <div>
        <div class="user-details-imageCrop-container" *ngIf="imageChangedEvent">
          <image-cropper #imageCropper [imageChangedEvent]="imageChangedEvent"
                         [maintainAspectRatio]="true"
                         [aspectRatio]="10 / 10"
                         format="png"
                         [resizeToWidth]="150"
                         [resizeToHeight]="150"
                         (imageCropped)="imageCropped($event)"
                         (imageLoaded)="imageLoaded()"
                         (cropperReady)="cropperReady()"
                         (loadImageFailed)="loadImageFailed()"></image-cropper>
        </div>
      </div>
      <div class="user-details-profile-image-divider">
        <mat-divider></mat-divider>
      </div>
      <div class="user-details-profile-image-divider">
        <button mat-raised-button color="primary" (click)="dialogRef.close('yes')">Set profile picture</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading-container">
    <span class="loading-content">
      <div class="spinner-div"><mat-spinner [diameter]="25"></mat-spinner></div>
      <div class="spinner-text"> Please Wait...</div>
    </span>
  </div>
</ng-template>

